import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  variant?: 'violet' | 'gold';
}
export function CTAButton({
  children,
  href = '#pricing',
  className = '',
  variant = 'violet'
}: CTAButtonProps) {
  const isAnchor = href.startsWith('#');
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isAnchor) {
      e.preventDefault();
      const el = document.getElementById(href.substring(1));
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const palette = variant === 'gold' ? 'bg-brand-gold text-brand-navy hover:bg-brand-goldDark border-b-4 border-brand-goldDark shadow-[0_4px_14px_0_rgba(216,175,61,0.45)]' : 'bg-brand-violet text-white hover:bg-brand-violetHover border-b-4 border-brand-violetHover shadow-[0_4px_14px_0_rgba(91,111,232,0.45)]';
  const classes = `
    block w-full text-center cursor-pointer
    px-4 py-4
    font-heading font-extrabold text-sm sm:text-lg uppercase tracking-wide
    rounded-lg
    ${palette}
    hover:scale-[1.02] active:border-b-0 active:translate-y-1
    transition-all duration-200
    ${className}
  `;
  return <a href={href} onClick={handleClick} target={isAnchor ? undefined : '_blank'} rel={isAnchor ? undefined : 'noopener noreferrer'} className={classes} data-id="element-32">
      {children}
    </a>;
}